// Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
// See LICENSE in the project root for license information.

import { RushHttpBuildCachePlugin } from './RushHttpBuildCachePlugin';

export default RushHttpBuildCachePlugin;
export type { IHttpBuildCacheProviderOptions, UploadMethod } from './HttpBuildCacheProvider';
